module.exports = __webpack_public_path__ + "img/sqlalchemylogo.794b07d6.png";